import { useState, useEffect } from "react"
import "./adminsList.css"
import { Visibility } from "@material-ui/icons"
import { serverAPI } from "../../services/apiParams"
import { Link } from "react-router-dom"
export default function WidgetSm() {
  const [users, setUsers] = useState()

  useEffect(() => {
    const getUsers = async () => {
      try {
        //here get only the admins
        const res = await serverAPI.get("api/users", {
          params: {
            admin: true,
          },
        })
        setUsers(res.data.users)
      } catch (error) {
        console.log(error.response)
      }
    }
    getUsers()
  }, [])

  return (
    <div className='widgetSm'>
      <span className='widgetSmTitle'>Admins</span>
      <ul className='widgetSmList'>
        {users &&
          users.map((user) => {
            return (
              <li className='widgetSmListItem' key={user.id}>
                <div className='widgetSmUser'>
                  <span className='widgetSmUsername'>
                    {user.last_name} {user.first_name}
                  </span>
                  <span className='widgetSmUserTitle'>{user.email}</span>
                </div>
                <Link to={"/user/" + user.id} className='widgetSmButton'>
                  <Visibility className='widgetSmIcon' />
                  Info
                </Link>
              </li>
            )
          })}
      </ul>
    </div>
  )
}
